import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Lang, LangEnum, LangCode } from "../utils/lang"
import { useState } from 'react';
import { init, Form } from '@feathery/react';
import { useLocation } from '@reach/router';

const FlightExampleItem = ({blok}) => {
  // console.log(blok)

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const affiliate = queryParams.get('affiliate');
  var initialValues = {}
  initialValues['affiliate'] = affiliate ? affiliate : '';
  // console.log(initialValues)

  const lang = Lang()
  const langCode = LangCode()
  
  // Initialize Feathery
  init('eeaa5623-09b6-42e5-944d-b11974b0154b');
  const [showPopup, setShowPopup] = useState(false);

  let currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

  return (
    <div className="airfare-card" {...storyblokEditable(blok)}>
      <div className="text-xs my-2 h-3">
        {blok.note &&<img className="w-3 h-3 mr-1 inline-block" src="/icons/caution-black.svg" alt="Caution icon"/>}
        {blok.note}
      </div>
      <div className="border-sky-950 border rounded-lg w-[345px] flex justify-between">
        <div className="w-4/5">
          <div className="font-bold text-lg p-2 border-b flex gap-1 justify-center items-center">
            {blok.departAt} {lang == LangEnum.JA && '発'}
            <img className="w-[28px] h-[28px] mx-1" src="/icons/flight-airplane.svg" alt="Airplaine icon"/>
            {blok.arriveAt} {lang == LangEnum.JA && '行'}
          </div>

          <div className="text-xs">
            <dl className="grid grid-cols-[auto,1fr]">
              <dt className="text-blue-400 p-3 border-r border-dashed flex items-center">
              <img className="w-[15px] h-[20px] mr-1 inline-block" src="/icons/flight-economy.svg" alt="Flight economy icon"/>
                <span>{ lang == LangEnum.JA ? 'エコノミー' : 'Economy'}</span>
              </dt>
              <dd className="py-2 px-3 font-bold text-lg">{currencyFormat.format(blok.economyPrice)}〜</dd>
              <dt className="text-emerald-500 p-3 border-r border-dashed flex items-center">
                <img className="w-[22px] h-[20px] inline-block" src="/icons/flight-premium-economy.svg" alt="Flight premiun economy icon"/>
                { lang == LangEnum.JA ? 'プレエコ' : 'Premium Economy'}
              </dt>
              <dd className="py-2 px-3 font-bold text-lg">{currencyFormat.format(blok.premiumEconomyPrice)}〜</dd>
            </dl>
          </div>
        </div>

        {/* #TODO: Set URL */}
        <div className="w-1/5 rounded-lg flex flex-col justify-center items-center">
          <a className="bg-red-600 rounded-t-lg w-full h-1/2 flex flex-col justify-center items-center text-white text-sm font-serif border-b border-b-white"
            href={`tel: ${blok.tel}`}>
            <img className="w-[22px] h-[20px] mb-1" src="/icons/flight-tel.svg" alt="Tel icon"/>
            { lang == LangEnum.JA ? '電話' : 'Tel'}
          </a>
          <button onClick={() => setShowPopup(true)} 
            className="bg-sky-950 rounded-b-lg w-full h-1/2 flex flex-col justify-center items-center text-white text-sm font-serif border-t border-t-white">
            <img className="w-[14px] h-[16px] mb-1" src="/icons/flight-form.svg" alt="Form icon"/>
            { lang == LangEnum.JA ? 'フォーム' : 'Inquiry'}
          </button>
          <Form
            className="bg-white"
            formName={blok.formName}
            initialValues={initialValues}
            language={langCode}
            popupOptions={{
              show: showPopup,
              onHide: () => setShowPopup(false),
            }}
          />
          
        </div>
      </div>
    </div>
  )
}
  
export default FlightExampleItem
